import { Link } from "react-router-dom";
import { blogList, workList } from "../data.js";
import { localizeField } from "../i18n.js";
import PostRow from "./PostRow.jsx";

export default function HomePage({ t, copy, language }) {
  const latestProjects = [...workList]
    .sort((a, b) => Number(b.year || 0) - Number(a.year || 0))
    .slice(0, 3);
  const latestBlogs = [...blogList]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 2);

  return (
    <div>
      <img
        src="/img/pixel.png"
        alt="Hamza Ouabiba"
        style={{
          borderRadius: 8,
          display: "block",
          height: 200,
          marginBottom: 22,
          objectFit: "cover",
          width: 200,
        }}
      />

      <h2 style={{ fontSize: 20, fontWeight: 400, marginBottom: 18 }}>{copy.homeTitle}</h2>

      <p style={{ color: t.muted, marginBottom: 16 }}>
        {copy.homeIntro}
      </p>

      <section style={sectionStyle}>
        <SectionHeader title={copy.latestProjects} to="/projects" label={copy.seeAll} t={t} />
        <div>
          {latestProjects.map((item, index) => (
            <PostRow
              key={item.id}
              root="projects"
              path={item.id}
              label={item.year}
              title={localizeField(item, "title", language)}
              subtitle={localizeField(item, "subtitle", language)}
              isFirst={index === 0}
              link
              t={t}
              copy={copy}
            />
          ))}
        </div>
      </section>

      <section style={sectionStyle}>
        <SectionHeader title={copy.latestBlogPosts} to="/blog" label={copy.seeAll} t={t} />
        <div>
          {latestBlogs.map((post, index) => (
            <PostRow
              key={post.id}
              root="blog"
              path={post.id}
              label={post.date}
              title={localizeField(post, "title", language)}
              isFirst={index === 0}
              link
              t={t}
              copy={copy}
              language={language}
            />
          ))}
        </div>
      </section>
    </div>
  );
}

function SectionHeader({ title, to, label, t }) {
  return (
    <div style={sectionHeaderStyle}>
      <h2 style={{ fontSize: 20, fontWeight: 400, margin: 0 }}>{title}</h2>
      <Link
        to={to}
        style={{
          color: t.dim,
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: 12,
          textDecoration: "none",
        }}
      >
        {label}
      </Link>
    </div>
  );
}

const sectionStyle = {
  marginTop: 34,
};

const sectionHeaderStyle = {
  alignItems: "baseline",
  display: "flex",
  gap: 16,
  justifyContent: "space-between",
  marginBottom: 14,
};
